import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';
import { PendingChange } from '@/shared/config';

import { AssetID, DetectionID, ToothDetectionWithMetadata } from '../config';

export const buildDataByAssetAndDetection = (
  teeth: Tooth[],
  changesByAssetID: Map<AssetID, Map<DetectionID, PendingChange>>,
) => {
  return teeth.reduce((acc, tooth) => {
    const ISO = tooth.Numeration?.ISO;
    const supernumeraryIndex = tooth.Numeration?.SupernumeraryIndex || 0;
    if (!ISO) {
      return acc;
    }

    return tooth.Detections.reduce((innerAcc, detection) => {
      const assetID = detection.Localizations?.TargetAssetID;
      const isoNumber = tooth.Numeration?.ISO;
      if (!assetID || !isoNumber) {
        return innerAcc;
      }

      const detectionID = detection.ID;
      const pendingChange = changesByAssetID.get(assetID)?.get(detectionID);

      const existingAssetMap = innerAcc.get(assetID) || new Map();
      const updatedAssetMap = new Map(existingAssetMap);
      updatedAssetMap.set(detectionID, {
        change: pendingChange || null,
        tooth: { detection, ISO, idx: supernumeraryIndex },
      });

      return new Map(innerAcc).set(assetID, updatedAssetMap);
    }, acc);
  }, new Map<AssetID, Map<DetectionID, ToothDetectionWithMetadata>>());
};
